<div class="flxClmn bs-enabled">

    <div class="page-title-container flxRow">
        <div class="flxClmn-center justify-content-between f-1-0">
            <div class="page-title-inner-container flxRow">
                <span class="page-title">Discovered Services</span>
            </div>
            <div class="page-subtitle-container">
                <span class="page-subtitle">
                    Apps and services in use across your company, so you can assess risk and exposure
                </span>
            </div>
        </div>
        <div class="control-and-info-icons flxRow"></div>
    </div>

    <div class="page-inner-content-holder no-scroll flxClmn">
        <trustifi-table-c
                class="trustifi-table" style="flex: 1 0; z-index: 5;"
                [list]="discoveredServices"
                [headers]="[
                        {text: 'Service', sortKey: 'name'},
                        {text: 'Exposure Level', sortKey: 'data.risk', tooltip: riskyTooltip('all'), toolTipHtml: true},
                        {text: '# Mailboxes', sortKey: 'mailboxesCounter', width: '170px', tooltip: 'Number of mailboxes in your organization that interact with this service'},
                        {text: 'Last Seen', sortKey: 'updated', width: '15%'},
                    ]"
                [cellsPrototype]="[
                        {html: 'websiteCell'},
                        {html: 'riskyCell'},
                        {html: 'mailboxesCounterCell'},
                        {textKey: 'updated', textType: 'dateAndTime'},

                    ]"
                [cellActions]="{
					enable: true,
					selectItemActionCb:	selectAction,
					initActionsFunction: showServicesActions
				}"
                [options]="{
                        exportToCsvFunction: exportToCsv,
                        itemsNameSingular: 'service',
                        loadingTableFlag: getServicesInProcess,
                        defaultSortKey: '-mailboxesCounter'
                    }"
                [scopeInstances]="[{showMailboxesByServiceFromCell: showMailboxesByServiceFromCell}]"
                (searchFunction)="searchService($event)"
                [filterData]="filterData"
        >
			<ng-template #customCells let-item let-cellId="cellId">
				<!--mailboxesCounter cells-->
				<span>
					<a class="blue-link text-decoration-underline fw-bold d-block text-center" style="font-size: 1rem; width: 80px;"
					   *ngIf="cellId === 'mailboxesCounterCell'"
					   (click)="showMailboxesByServiceFromCell(item)">
						<span>{{item.mailboxesCounter}}</span>
					</a>
				</span>
				<!--Website cells-->
				<span style="padding-right: 80px; display: block;">
                    <a class="blue-link flex-row gap-2 align-items-center" href="{{item.website}}" target="_blank"
					   *ngIf="cellId === 'websiteCell'">
                        <img alt="" style="height: 20px;" *ngIf="item.domain" src="https://www.google.com/s2/favicons?domain={{item.domain}}">
                        <span>{{item.name}}</span>
                    </a>
                </span>
				<!--risk cells-->
				<!--CC: taken from quarantined-email-action.component.html -> threat-tag chip (replaces the legacy underlined link + bar chart)-->
				<div class="flxClmn-center h100" *ngIf="cellId === 'riskyCell'">
					<div class="flxRow threat-tag not-clickable" style="align-items: center; padding: 4px 12px; margin: 0;"
						 [tooltip]="riskyTooltip(item.data.risk)"
						 [ngClass]="item.data.risk === 5 ? 'darkred' : item.data.risk === 4 ? 'darkorange' : item.data.risk === 3 ? 'darkblue' : 'darkgreen'">
						<div class="threat-tag-BG"></div>
						<span class="threat-tag-text m-0" style="font-size: inherit;">{{riskyToString(item.data.risk)}}</span>
					</div>
				</div>
				<!---->
			</ng-template>
        </trustifi-table-c>
    </div>

    <!--view mailboxes for service popup-->
    <popup-c *ngIf="showMailboxesByServicePopup?.show"
           head="Mailboxes receiving emails from {{showMailboxesByServicePopup.serviceObj.data.name}}"
           (closeCb)="showMailboxesByServicePopup = null;"
           [buttons]="{cancel: 'OK'}" size="medium">
        <div class="flex-column f-1-0 gap-2" style="overflow: auto;">
            <trustifi-table-c
                    class="trustifi-table" style="flex: 1 0; z-index: 5;"
                    [list]="showMailboxesByServicePopup?.serviceObj.mailboxes"
                    [headers]="[
                                    {text: 'Last Seen', sortKey: 'updated', width: '30%'},
                                    {text: 'Email', sortKey: 'email'},
                                ]"
                    [cellsPrototype]="[
                                    {textKey: 'updated', textType: 'dateAndTime'},
                                    {textKey: 'email'},
                                ]"
                    [options]="{
                                    itemsNameSingular: 'user',
                                    defaultSortKey: '-updated'
                                }"
                    (searchFunction)="searchUser($event)"
            >
            </trustifi-table-c>
        </div>
    </popup-c>
</div>
